import styled from "@emotion/styled";
export const Head = styled.div`
  color: #fff;
  float: left;
  padding: 10px;
  padding-left: 28px;
  font-family: Tangerine;
  font-size: 34px;
  font-weight: bold;
  line-height: 1.56;
  color: #ffffff;
`;
